import React, { useState, useEffect, useCallback } from "react";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import { Typography, Fade, Input } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import bigInt from "big-integer";

import { withNamespaces } from "react-i18next";
import { isVotePassed, toFixed, tokens } from "../../constants";

import Store from "../../stores";
import Table from "./components/Table";
import { getStatusText } from "./components/Status";
import Spinner from "../stake/components/Spinner";
import { sortPools } from "../../utils/sortPools";
import moment from "moment";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
    fontFamily: "Poppins",
    position: "relative",
  },
  mainContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100vw",
    overflow: "auto",
    maxWidth: "1140px",
  },
  logo: {
    width: "250px",
    height: "250px",
    objectFit: "contain",
    marginBottom: "1rem",
  },
  header: {
    fontSize: "30px",
    lineHeight: "35px",
    fontFamily: "Poppins",
    fontWeight: "bold",
    textAlign: "center",
    color: theme?.colors?.home?.heading,
    marginBottom: "10px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "50px",
      lineHeight: "60px",
      maxWidth: "768px",
      marginBottom: "20px",
    },
  },
  headerSecondary: {
    fontSize: "30px",
    lineHeight: "35px",
    fontWeight: "bold",
    textAlign: "left",
    color: theme?.colors?.home?.headingSecondary,
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "50px",
      lineHeight: "60px",
    },
  },
  headerSubText: {
    fontSize: "10px",
    fontFamily: "Poppins",
    lineHeight: "15px",
    fontWeight: "lighter",
    textAlign: "justify",
    letterSpacing: "0px",
    color: theme?.colors?.home?.textSecondary,
    width: "100%",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "20px",
      lineHeight: "20px",
      maxWidth: "660px",
      marginBottom: "60px",
    },
  },
  headerActionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "100px",
    },
  },
  mainBody: {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    padding: "30px",

    [theme.breakpoints.up("sm")]: {
      padding: "70px",
    },
  },
  poolsContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "75px",
    },
  },
  poolsLabel: {
    fontFamily: "Poppins",
    fontSize: "30px",
    fontWeight: "600",
    lineHeight: "36px",
    textAlign: "left",
    letterSpacing: "0px",
    color: theme?.colors?.home?.text,
  },
  filterBtn: {
    margin: "0 8px",
    cursor: "pointer",
    color: "#A0A0A0",
    border: "none",
    background: "none",
    padding: "8px 16px",
    "&:hover": {
      opacity: 0.6,
    },
  },
  activeFilterBtn: {
    padding: "8px 16px",
    margin: "0 8px",
    cursor: "pointer",
    color: "#fff",
    border: "none",
    background: theme?.colors?.wallet?.buttonBackground,
    borderRadius: "25px",
    "&:hover": {
      background: theme?.colors?.wallet?.buttonBackgroundHover,
    },
    width: "100%",
  },
  filtersContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    gap: "24px",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  filters: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",

    width: "100%",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  poolsWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridColumnGap: "30px",
    gridRowGap: "40px",

    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },

    [theme.breakpoints.up("lg")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridColumnGap: "30px",
      gridRowGap: "40px",
    },
  },
  poolItemWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontSize: "16px",
    fontWeight: "lighter",
    textAlign: "left",
    color: theme?.colors?.home?.text,
    lineHeight: "24px",
    marginBottom: "15px",
    marginTop: "0px",
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
    },
  },
  poolButton: {
    borderRadius: "14px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonText,
    textTransform: "capitalize",
    height: "40px",
    width: "170px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonText,
    },
    fontFamily: "Poppins",

    marginRight: "5px",
    marginLeft: "5px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "15px",
      marginLeft: "15px",
    },
  },
  joinButton: {
    borderRadius: "14px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 1px" + theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    width: "170px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: "transparent",
      color: theme?.colors?.wallet?.buttonBackgroundHover,
      border: "solid 1px" + theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",

    marginRight: "5px",
    marginLeft: "5px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "15px",
      marginLeft: "15px",
    },
  },
  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    whiteSpace: "nowrap",
  },
  emptyContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "24px",
  },
  tableContainer: {
    width: "300px",
    overflow: "auto",
  },
  loader: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "62px",
  },
  warningContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    height: "50px",
    padding: "10px 20px",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    borderRadius: "12px",
  },
  warningText: {
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textAlign: "center",
    fontSize: "20px",
    lineHeight: "25px",
  },
  poolsTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "30px",
  },

  searchBox: {
    width: "100%",
    height: "40px",
    borderRadius: "24px",
    border: "solid 1px " + theme?.colors?.pools?.border,
  },
  searchInput: {
    fontSize: "15px",
    lineHeight: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.pools?.searchText,
    padding: "0px",
    minWidth: "180px",
  },

  searchMagnifier: {
    width: "17px",
    height: "17px",
    margin: "16px",
    color: theme?.colors?.pools?.searchMagnifier,
  },

  paginationContainer: {
    marginTop: "30px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  paginationUl: {
    "& > li:first-child > button": {
      border: "solid 1px " + theme?.colors?.pools?.paginationItemBorder,
      borderRadius: "8px",
    },
    "& > li:last-child > button": {
      border: "solid 1px " + theme?.colors?.pools?.paginationItemBorder,
      borderRadius: "8px",
    },
  },

  paginationItemRoot: {
    width: "35px",
    height: "25px",
  },

  paginationItemRounded: {
    color: theme?.colors?.pools?.paginationText,
  },
  paginationItemSelected: {
    backgroundColor:
      theme?.colors?.pools?.paginationItemSelectedBkg + " !important",
    color: theme?.colors?.pools?.paginationItemSelectedText,
    borderRadius: "8px",
  },
});

const store = Store.store;

const Pools = ({ classes }) => {
  const [pools, setPools] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [filteredPools, setFilteredPools] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const isInVoting = (pool) => {
    if (pool.certified) {
      return false;
    }
    const currentTimestamp = Math.floor(Date.now() / 1000);

    return (
      !pool.presaleCancelled &&
      pool.openTime > currentTimestamp &&
      pool.presaleType !== "2"
    );
  };

  const getPoolsSummaryReturned = useCallback(() => {
    const publicPresales = store.getStore("publicPresales");

    const filteredPublicPresales = sortPools(
      Object.values(publicPresales).filter((presale) => {
        const isCancelled = presale?.presaleCancelled;
        const isEnded = moment.unix(presale.closeTime).isBefore(moment.now());

        const totalCollected = parseFloat(
          toFixed(
            bigInt(presale?.totalCollectedWei || "0"),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            3
          )
        );
        const softCap = parseFloat(
          toFixed(
            bigInt(presale?.softCapInWei || "0"),
            tokens[presale?.fundingTokenAddress]?.decimals ?? 18,
            3
          )
        );

        if (presale?.visible && !isCancelled && totalCollected >= softCap) {
          return true;
        }

        if (presale?.certified) {
          return presale?.visible && !isCancelled && !isEnded;
        } else {
          return (
            presale?.visible &&
            !isInVoting(presale) &&
            isVotePassed(presale) &&
            !isCancelled &&
            !isEnded
          );
        }
      })
    );

    if (pools.length !== filteredPublicPresales.length) {
      setPools(filteredPublicPresales);
    }
    setIsLoading(false);
  }, [pools]);

  useEffect(() => {
    getPoolsSummaryReturned();

    const watchPoolsChangeId = setInterval(() => {
      getPoolsSummaryReturned();
    }, 1000);

    return () => {
      clearInterval(watchPoolsChangeId);
    };
  }, [getPoolsSummaryReturned]);

  useEffect(() => {
    if (!searchString || searchString === "") {
      setFilteredPools(pools);
      return;
    }
    const filteredData = pools.filter((item) => {
      const totalParticipants = item?.totalInvestorsCount ?? "0";

      return (
        item?.saleTitle
          ?.toLowerCase()
          .trim()
          .includes(searchString?.toLowerCase()) ||
        totalParticipants
          ?.toLowerCase()
          .trim()
          .includes(searchString?.toLowerCase()) ||
        getStatusText(item)
          ?.toLowerCase()
          .trim()
          .includes(searchString?.toLowerCase()) ||
        tokens[item?.fundingTokenAddress]?.label
          ?.toLowerCase()
          .trim()
          .includes(searchString?.toLowerCase()) ||
        parseFloat(
          toFixed(
            bigInt(item?.totalCollectedWei || "0"),
            tokens[item?.fundingTokenAddress]?.decimals ?? 18,
            3
          )
        )
          .toFixed(3)
          .includes(searchString?.toLowerCase()) ||
        parseFloat(
          toFixed(
            bigInt(item?.hardCapInWei) || "0",
            tokens[item?.fundingTokenAddress]?.decimals ?? 18,
            3
          )
        )
          .toFixed(3)
          .includes(searchString?.toLowerCase()) ||
        parseFloat(
          toFixed(
            bigInt(item.tokenPriceInWei || "0"),
            tokens[item?.fundingTokenAddress]?.decimals ?? 18,
            3
          )
        )
          .toFixed(3)
          .includes(searchString?.toLowerCase())
      );
    });

    setFilteredPools(filteredData);
  }, [pools, searchString]);

  return (
    <div className={classes.root}>
      <Fade in={true} timeout={{ enter: 1000 }}>
        <div className={classes.mainContainer}>
          <div className={classes.mainBody}>
            <div className={classes.poolsContainer}>
              <div className={classes.poolsTitleContainer}>
                <Typography className={classes.poolsLabel}>
                  All Projects
                </Typography>
              </div>

              <div className={classes.filtersContainer}>
                <Input
                  classes={{
                    root: classes.searchBox,
                    input: classes.searchInput,
                  }}
                  disableUnderline={true}
                  placeholder="Search by Name, Status, Funding Token..."
                  value={searchString}
                  startAdornment={
                    <SearchIcon classes={{ root: classes.searchMagnifier }} />
                  }
                  onChange={(ev) => {
                    setSearchString(ev.target.value);
                  }}
                />
              </div>

              {isLoading ? (
                <div className={classes.loader}>
                  <Spinner strokeSize="6px" width="54px" height="54px" />
                </div>
              ) : filteredPools.length === 0 ? (
                <div className={classes.emptyContainer}>
                  <div className={classes.warningContainer}>
                    <Typography variant="h4" className={classes.warningText}>
                      No projects yet...
                    </Typography>
                  </div>
                </div>
              ) : (
                <Table data={filteredPools} />
              )}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(Pools)));
